import { ApprovalTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1980. 承認タスク一覧
 * [GET] /workspaces/:identifier/approval_tasks
 */
type Props = {
  identifier: string;
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  enabled?: boolean;
};

const approvalTasks = (props: Props): Promise<ApprovalTask[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/approval_tasks`, { params: props });
};

export const useApprovalTasks = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => approvalTasks(props),
    enabled: props.enabled,
  });
};

export const useApprovalTasksInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', props.identifier, 'approval_tasks'] });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'approval_tasks', { ...props }];
};
